import PagesScreen from './PagesScreen';

export default PagesScreen;
